// SocialPulse SSO — OIDC Authorization Code flow with PKCE (S256).
// Public client (no secret). The backend exchanges the code + verifier.
import { isIndia } from "./edition";

const AUTH_ENDPOINT = "https://socialpulse.com/api/oauth/authorize";
export const SOCIALPULSE_CLIENT_ID =
  process.env.REACT_APP_SOCIALPULSE_CLIENT_ID || (isIndia ? "indiaalumni-web" : "alumnipulse-web");

export function socialpulseRedirectUri() {
  return `${window.location.origin}/auth/socialpulse-callback`;
}

function b64url(bytes) {
  return btoa(String.fromCharCode(...new Uint8Array(bytes)))
    .replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}
function randomB64url(n) {
  const bytes = new Uint8Array(n);
  crypto.getRandomValues(bytes);
  return b64url(bytes.buffer);
}

export async function startSocialPulseLogin({ keep = true } = {}) {
  const codeVerifier = randomB64url(32); // 43-char verifier
  const challenge = b64url(
    await crypto.subtle.digest("SHA-256", new TextEncoder().encode(codeVerifier))
  );
  const state = randomB64url(32);
  const nonce = randomB64url(32);

  sessionStorage.setItem("sp_state", state);
  sessionStorage.setItem("sp_verifier", codeVerifier);
  sessionStorage.setItem("sp_nonce", nonce);
  sessionStorage.setItem("sp_keep", keep ? "1" : "0");

  const q = new URLSearchParams({
    response_type: "code",
    client_id: SOCIALPULSE_CLIENT_ID,
    redirect_uri: socialpulseRedirectUri(),
    scope: "openid profile email",
    state,
    nonce,
    code_challenge: challenge,
    code_challenge_method: "S256",
  });
  window.location.assign(`${AUTH_ENDPOINT}?${q.toString()}`);
}
